var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-main-listado-anticipos"}},[(!_vm.$vuetify.breakpoint.xs)?[_c('desktop',{attrs:{"listadoResponsables":_vm.listadoResponsables}})]:[_c('mobile',{attrs:{"listadoResponsables":_vm.listadoResponsables}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }